import 'css-chunksrc/client/scenes/workloads/graph/elementsOverlay/element/derivation/styles.scss';export default {
  "derivation": "_derivation_1rc89_1",
  "indicator": "_indicator_1rc89_7"
};